export default __webpack_public_path__ + "images/UT.a3f3edd.png";